export class BaseSearchParam<T> {
    sort?: string
    pageSize?: number
    pageNumber?: number
    filter?: T

    constructor(filter: T, sort?: string, pageSize?: number, pageNumber?: number) {
        this.filter = filter;
        this.sort = sort;
        this.pageSize = pageSize;
        this.pageNumber = pageNumber;
    }

    buildQueryString(): string {
        const queryParams = [];

        if (this.sort) queryParams.push(`sort=${encodeURIComponent(this.sort)}`);
        if (this.pageSize) queryParams.push(`page.size=${encodeURIComponent(this.pageSize.toString())}`);
        if (this.pageNumber) queryParams.push(`page.number=${encodeURIComponent(this.pageNumber.toString())}`);

        // Convert filter object to query parameters (assuming filter is an object with key-value pairs)
        if (this.filter) {
            for (const key in this.filter) {
                if (Object.prototype.hasOwnProperty.call(this.filter, key)) {
                    const value = this.filter[key];
                    queryParams.push(`${key}=${encodeURIComponent(value.toString())}`);
                }
            }
        }

        return queryParams.length > 0 ? '?' + queryParams.join('&') : '';
    }
}